<template>
    <div>
        <!-- Onboarding Banner 1 -->
        <b-alert
            v-if="tab.onboarding_banner_1 === 0 && showNextBanner"
            show
            variant="info"
            dismissible
            @dismissed="dismissAndDelay('1')"
        >
            <p>
                <strong>Generate Changelog Entries</strong><br>
                Keep your users updated by creating multiple changelog posts using AI or git2log, which uses your git commits to make the changelog.
            </p>
            <b-button @click="generateChangelogPosts(); setOnboardingDone('1')" variant="primary">
                Generate Changelog Posts
            </b-button>
            <b-button @click="git2log(); setOnboardingDone('1')" variant="primary">Git2Log</b-button>
            <b-button @click="dismissAndDelay('1')" variant="link" class="text-muted">
                Skip <b-icon icon="arrow-right"></b-icon>
            </b-button>
        </b-alert>

        <!-- Onboarding Banner 2 -->
        <b-alert
            v-else-if="tab.onboarding_banner_2 === 0 && showNextBanner"
            show
            variant="warning"
            dismissible
            @dismissed="dismissAndDelay('2')"
        >
            <p>
                <strong>Update Status to Changelog</strong><br>
                Quickly move finished features from your roadmap to your changelog. Just update the post's status and tag a comment for the changelog description.
            </p>
            <b-button @click="confirm(); setOnboardingDone('2')" variant="primary">OK</b-button>
        </b-alert>

        <!-- Onboarding Banner 3 -->
        <b-alert
            v-else-if="tab.onboarding_banner_3 === 0 && showNextBanner"
            show
            variant="success"
            dismissible
            @dismissed="dismissAndDelay('3')"
        >
            <p>
                <strong>Share Your Latest Updates</strong><br>
                Let your users know what's new. Embed your changelog in your app or share the link.
            </p>
            <b-button @click="getEmbedCode(); setOnboardingDone('3')" variant="primary">
                Get Embed Code
            </b-button>
            <b-button @click="copyChangelogLink(); setOnboardingDone('3')" variant="primary">
                Copy Changelog Link
            </b-button>
            <b-button @click="dismissAndDelay('3')" variant="link" class="text-muted">
                Skip <b-icon icon="arrow-right"></b-icon>
            </b-button>
        </b-alert>
    </div>
</template>

<script>
export default {
    props: {
        tab: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showNextBanner: true,
            nextBannerDelay: 5000,
        };
    },
    methods: {
        dismissAndDelay(key) {
            this.$set(this.tab, `onboarding_banner_${key}`, -1);
            this.$emit('onboarding-dismissed', `onboarding_banner_${key}`);
            this.showNextBanner = false;
            setTimeout(() => {
                this.showNextBanner = true;
            }, this.nextBannerDelay);
        },
        setOnboardingDone(key) {
            this.$set(this.tab, `onboarding_banner_${key}`, 1);
            this.$emit('onboarding-done', `onboarding_banner_${key}`);
            this.showNextBanner = false;
            setTimeout(() => {
                this.showNextBanner = true;
            }, this.nextBannerDelay);
        },
        generateChangelogPosts() {
            this.$emit('generate-changelog-posts');
        },
        git2log() {
            this.$emit('git2log');
        },
        confirm() {
            this.$emit('confirm');
        },
        getEmbedCode() {
            this.$emit('get-embed-code');
        },
        copyChangelogLink() {
            this.$emit('copy-changelog-link');
        },
    },
};
</script>
